import { axiosPublic } from '../../publicRest'
import { initialize } from './global-labels'
import { I18nLabelsQuery } from '../types/graphql'
import { gql } from 'graphql-request'
import { initQueryClient } from './query-client'
import { request } from './request'
import { PortalPropertiesDTO } from '@/core/types/properties'

const I18N_LABELS = gql`
  query I18nLabels {
    i18nLabels {
      key
      value
    }
  }
`

export const getProperties = async () => {
  const response =
    await axiosPublic.get<PortalPropertiesDTO>('/portalProperties')
  return response.data
}

export const initializeFaviconAndTitle = (manifest: {
  name?: string
  favicon?: string
}) => {
  const { favicon, name } = manifest

  document.querySelector('#favicon')?.setAttribute('href', String(favicon))
  document.title = String(name)
}

export const initializeI18n = async (
  client: ReturnType<typeof initQueryClient>
) => {
  const { i18nLabels } = await client.fetchQuery({
    queryKey: ['i18nLabels'],
    queryFn: async () => await request<I18nLabelsQuery>(I18N_LABELS)
  })

  initialize(i18nLabels)
}
